module.exports = __webpack_public_path__ + "media/images/arrow-up-dac945340e28b0609954a951002238b5.png";